import pl from "@locales/store_clinic/pl.json";
import en from "@locales/store_clinic/en.json";

export default {
  pl: pl,
  en: en,
};
